import React from 'react';

export const StickyBar = ({ children }: { children: React.ReactNode }) => (
    <div className="fixed inset-x-0 bottom-0 z-20 border-t bg-background/95 backdrop-blur md:left-[var(--sidebar-width)]">
        <div className="mx-auto flex max-w-[1400px] items-center justify-end gap-3 px-6 py-3">
            {children}
        </div>
    </div>
);
